<template>
	<!-- Modal -->
	<div id="municipalities-create" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  	<div class="modal-dialog modal-sm modal-dialog-centered" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
			        <h5 class="modal-title" id="exampleModalCenterTitle">Aggiungi Comune</h5>
			        <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
			          	<i class="tio-clear tio-lg"></i>
			        </button>
		      	</div>
		      	<div class="modal-body">
					<div class="form-group">
						<label class="font-weight-bold">Comune</label>
	                    <vue-google-autocomplete
	                        class="form-control"
	                        :class="{'is-invalid': form.errors.name}"
	                        @place_changed="getAddressData"
	                        placeholder="Nome"
	                        :types="types"
	                    ></vue-google-autocomplete>					

	                    <span class="invalid-feedback" v-if="form.errors.name" v-text="form.errors.name"></span>	
					</div>
					<div class="form-group">
						<label class="font-weight-bold">Attivo</label>
					  	<label class="toggle-switch toggle-sm mx-2" for="munSwitch">
						    <input type="checkbox" @change="onSetStatus" ref="switch" class="js-toggle-switch toggle-switch-input" id="munSwitch">
						    <span class="toggle-switch-label">
						      	<span class="toggle-switch-indicator"></span>
						    </span>
					  	</label>
					</div>
		      	</div>
		      	<div class="modal-footer">
		        	<button type="button" class="btn btn-white" data-dismiss="modal">Chiudi</button>
		        	<button type="button" @click="onSubmit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="btn btn-primary">Salva</button>
		      	</div>
		    </div>
	  	</div>
	</div>
	<!-- End Modal -->	
</template>

<script>
	import * as VueGoogleMaps from 'vue2-google-maps'

	export default {
		components: {
			'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
		},

		data() {
			return {
				types: ['(cities)'],
				form: this.$inertia.form({
                    name: null,
                    active: false,
                }),				
			}
		},

		mounted() {
			var toggleSwitch = new HSToggleSwitch(
				$(this.$refs.switch)
			).init();
		},

		methods: {
			getAddressData(payload) {
				let locality = this.getAddressComponent(payload, 'locality')
				this.form.name = locality.long_name
			},

            getAddressComponent(payload, type) {
                let {address_components} = payload

                return address_components.filter(i => i.types.includes(type))[0]
            },			

            onSetStatus(e) {
            	this.form.active = e.target.checked
            },

			onSubmit() {
				this.form.post(route('municipalities.store'), {
					onSuccess: () => {
						$('#municipalities-create').modal('hide')
					}
				})
			}
		}
	}
</script>